// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-49969529] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.header-menu[data-v-49969529] {
  position: relative;
  width: var(--header-height);
  height: var(--header-height);
}
.header-menu .header-menu__trigger[data-v-49969529] {
  width: 100% !important;
  height: var(--header-height);
  opacity: 0.85;
  filter: none !important;
  color: var(--color-primary-text) !important;
}
.header-menu--opened .header-menu__trigger[data-v-49969529], .header-menu__trigger[data-v-49969529]:hover, .header-menu__trigger[data-v-49969529]:focus, .header-menu__trigger[data-v-49969529]:active {
  opacity: 1;
}
.header-menu .header-menu__trigger[data-v-49969529]:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
.header-menu__wrapper[data-v-49969529] {
  position: fixed;
  z-index: 2000;
  top: 50px;
  inset-inline-end: 0;
  box-sizing: border-box;
  margin: 0 8px;
  padding: 8px;
  border-radius: 0 0 var(--border-radius) var(--border-radius);
  border-radius: var(--border-radius-large);
  background-color: var(--color-main-background);
  filter: drop-shadow(0 1px 5px var(--color-box-shadow));
}
.header-menu__carret[data-v-49969529] {
  position: absolute;
  z-index: 2001;
  bottom: 0;
  inset-inline-start: calc(50% - 10px);
  width: 0;
  height: 0;
  content: " ";
  pointer-events: none;
  border: 10px solid transparent;
  border-bottom-color: var(--color-main-background);
}
.header-menu__content[data-v-49969529] {
  overflow: auto;
  width: 350px;
  max-width: calc(100vw - 16px);
  min-height: 66px;
  max-height: calc(100vh - 100px);
}
.header-menu__content[data-v-49969529] .empty-content {
  margin: 12vh 10px;
}
@media only screen and (max-width: 512px) {
.header-menu[data-v-49969529] {
    width: 44px;
}
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcHeaderMenu-BbpDtHjf.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,2CAA2C;AAC7C;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,4DAA4D;EAC5D,yCAAyC;EACzC,8CAA8C;EAC9C,sDAAsD;AACxD;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,iDAAiD;AACnD;AACA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,iBAAiB;AACnB;AACA;AACA;IACI,WAAW;AACf;AACA","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-49969529] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.header-menu[data-v-49969529] {\n  position: relative;\n  width: var(--header-height);\n  height: var(--header-height);\n}\n.header-menu .header-menu__trigger[data-v-49969529] {\n  width: 100% !important;\n  height: var(--header-height);\n  opacity: 0.85;\n  filter: none !important;\n  color: var(--color-primary-text) !important;\n}\n.header-menu--opened .header-menu__trigger[data-v-49969529], .header-menu__trigger[data-v-49969529]:hover, .header-menu__trigger[data-v-49969529]:focus, .header-menu__trigger[data-v-49969529]:active {\n  opacity: 1;\n}\n.header-menu .header-menu__trigger[data-v-49969529]:focus-visible {\n  outline: none !important;\n  box-shadow: none !important;\n}\n.header-menu__wrapper[data-v-49969529] {\n  position: fixed;\n  z-index: 2000;\n  top: 50px;\n  inset-inline-end: 0;\n  box-sizing: border-box;\n  margin: 0 8px;\n  padding: 8px;\n  border-radius: 0 0 var(--border-radius) var(--border-radius);\n  border-radius: var(--border-radius-large);\n  background-color: var(--color-main-background);\n  filter: drop-shadow(0 1px 5px var(--color-box-shadow));\n}\n.header-menu__carret[data-v-49969529] {\n  position: absolute;\n  z-index: 2001;\n  bottom: 0;\n  inset-inline-start: calc(50% - 10px);\n  width: 0;\n  height: 0;\n  content: \" \";\n  pointer-events: none;\n  border: 10px solid transparent;\n  border-bottom-color: var(--color-main-background);\n}\n.header-menu__content[data-v-49969529] {\n  overflow: auto;\n  width: 350px;\n  max-width: calc(100vw - 16px);\n  min-height: 66px;\n  max-height: calc(100vh - 100px);\n}\n.header-menu__content[data-v-49969529] .empty-content {\n  margin: 12vh 10px;\n}\n@media only screen and (max-width: 512px) {\n.header-menu[data-v-49969529] {\n    width: 44px;\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
